import { BoxStairs } from "@/Box/BoxParts/BoxStairs";
import { Object3DTruePositionCalculator } from "@/calculators/Object3DTruePositionCalculator";
import { CustomColladaLoader } from "@/loaders/CustomColladaLoader";
import { BoxHelper } from "three";
import { Repository } from "./Repository";
import stairs from "../../configs/stairs.json";

export class StairsRepository extends Repository<BoxStairs> {
    
    private object3DTruePositionCalculator: Object3DTruePositionCalculator;

    public constructor () {
        super();
        this.object3DTruePositionCalculator = new Object3DTruePositionCalculator();
    }

    protected loadObjects() {
        const loader = new CustomColladaLoader();
        this.nbObjectTotal = (stairs as any[]).length;
        stairs.forEach(stairsItem => {
            loader.loadObj('models/'+stairsItem.location).then(instance => {
                instance.position.copy(this.object3DTruePositionCalculator.getTruePosition(instance));
                const hitbox = new BoxHelper(instance, 0xff0000);
                hitbox.update();
                this.objectMap.set(stairsItem.name, new BoxStairs(instance, hitbox, stairsItem.name));
                this.verifyIfEndLoading();
            })
        })
    }

    public getCopyByName(name: string): BoxStairs | undefined{
        if (this.objectMap.has(name)) {
            return this.objectMap.get(name)?.getCopy();
        }
        return undefined;
    }
    
}